import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { CdkTableModule } from '@angular/cdk/table';
import { HeaderComponent } from '../shared/header.component';
import { PostComponent } from '../shared/post.component';
import { PostDto, SessionDto } from '@oracychampions/api-interfaces';
import { map, Observable, tap } from 'rxjs';
import { SessionsService } from './sessions.service';

@Component({
  selector: 'oc-session-posts',
  standalone: true,
  imports: [CommonModule, RouterModule, CdkTableModule, HeaderComponent, PostComponent],
  template: `
    <div class="oc-posts-list p-4">
      <oc-post *ngFor="let post of posts$ | async" [post]="post" icon="tablerUser" [actions]="actions(post)"></oc-post>
    </div>
  `,
  styles: `
    .oc-posts-list {
      display: grid;
      grid-template-columns: repeat(1, minmax(0, 1fr));
      grid-template-rows: repeat(auto, 1fr);
      gap: 1rem;
      justify-content: start;

      oc-post {
        max-width: 580px;
        width: 580px;
        margin-right: auto;
      }
    }
  `,
})
export class SessionPostsComponent {
  private route = inject(ActivatedRoute);
  private sessionsService = inject(SessionsService);

  public posts$: Observable<PostDto[]>;

  session$: Observable<SessionDto>;
  session: any;

  constructor() {
    this.session$ = this.route.parent!.data.pipe(
      map((data) => data['session']),
      tap((session) => {
        this.session = session;
        this.posts$ = this.sessionsService.getPosts(session.id);
      }),
    );
    this.session$.subscribe();
  }

  actions(post: PostDto): any[] {
    return [];
  }
}
